const actions = {
    SUPPLIER_DETAILS_START: 'SUPPLIER_DETAILS_START',
    SUPPLIER_DETAILS_SUCCESS: 'SUPPLIER_DETAILS_SUCCESS',
    SUPPLIER_DETAILS_FAILURE: 'SUPPLIER_DETAILS_FAILURE',

    PURCHASE_SELFBILL_DETAILS_START: 'PURCHASE_SELFBILL_DETAILS_START',
    PURCHASE_SELFBILL_DETAILS_SUCCESS: 'PURCHASE_SELFBILL_DETAILS_SUCCESS',
    PURCHASE_SELFBILL_DETAILS_FAILURE: 'PURCHASE_SELFBILL_DETAILS_FAILURE',

    SUPPLIER_PAYMNET_DETAILS_START: 'SUPPLIER_PAYMNET_DETAILS_START',
    SUPPLIER_PAYMNET_DETAILS_SUCCESS: 'SUPPLIER_PAYMNET_DETAILS_SUCCESS',
    SUPPLIER_PAYMNET_DETAILS_FAILURE: 'SUPPLIER_PAYMNET_DETAILS_FAILURE',

    SUPPLIER_INVOICE_DETAILS_START: 'SUPPLIER_INVOICE_DETAILS_START',
    SUPPLIER_INVOICE_DETAILS_SUCCESS: 'SUPPLIER_INVOICE_DETAILS_SUCCESS',
    SUPPLIER_INVOICE_DETAILS_FAILURE: 'SUPPLIER_INVOICE_DETAILS_FAILURE',   

    SUPPLIER_BANK_DETAILS_START: 'SUPPLIER_BANK_DETAILS_START',
    SUPPLIER_BANK_DETAILS_SUCCESS: 'SUPPLIER_BANK_DETAILS_SUCCESS',
    SUPPLIER_BANK_DETAILS_FAILURE: 'SUPPLIER_BANK_DETAILS_FAILURE',   

    CLEAR_PURCHASE_MANAGEMENT_DETAILS_START: 'CLEAR_PURCHASE_MANAGEMENT_DETAILS_START',
    CLEAR_PURCHASE_MANAGEMENT_DETAILS_SUCCESS: 'CLEAR_PURCHASE_MANAGEMENT_DETAILS_SUCCESS'

};

export default actions;